module.exports = __webpack_public_path__ + "static/media/close-icon-white.45680413.svg";